var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4083 4.31656V13.7332C17.4083 15.3832 16.0667 16.7249 14.4167 16.7249C12.775 16.7249 11.425 15.3832 11.425 13.7332C11.425 12.0916 12.775 10.7499 14.4167 10.7499C15.1167 10.7499 15.7417 10.9916 16.25 11.3916V6.43323L8.57499 8.61656V15.3416C8.57499 16.9916 7.22499 18.3332 5.58333 18.3332C3.93333 18.3332 2.59166 16.9916 2.59166 15.3416C2.59166 13.6999 3.93333 12.3582 5.58333 12.3582C6.27499 12.3582 6.89999 12.5999 7.40833 12.9916V5.6249C7.40833 4.3999 8.14999 3.4499 9.32499 3.13323L14.1417 1.81656C15.1167 1.5499 15.9417 1.64156 16.525 2.09156C17.1167 2.53323 17.4083 3.28323 17.4083 4.31656Z",
    fill: "#5DCCC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.43e6c0e30c4ec0071ba850b4c7549855.svg";
export { ForwardRef as ReactComponent };